import { primitiveColors } from 'fitify-ui/src/theme/generated/primitive-colors'
import { zIndexes } from 'fitify-ui-onboarding/src/theme/zIndexes'
import { styled } from 'styled-components'

export const TRANSITION_LENGTH_MS = 200

export const StyledContainer = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  z-index: ${zIndexes.pageLoader};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${primitiveColors['New Primitives Web']['General/White']};
  color: ${primitiveColors['New Primitives Web']['General/Black']};
  inset: 0;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity ${TRANSITION_LENGTH_MS}ms;
`
